import { useReducer } from 'react';

const initialState = {
    rejectedTouches: new Set(),
    activeTouches: new Map(),
    recentRejections: [],
    activeStrokesByTouch: new Map(),
    primaryDrawingTouch: null,
    currentInputMethod: 'unknown'
};

const palmRejectionReducer = (state, action) => {
    switch (action.type) {
        case 'ADD_REJECTED_TOUCH':
            const newRejected = new Set(state.rejectedTouches);
            newRejected.add(action.payload);
            return { ...state, rejectedTouches: newRejected };
        case 'REMOVE_REJECTED_TOUCH':
            const updatedRejected = new Set(state.rejectedTouches);
            updatedRejected.delete(action.payload);
            return { ...state, rejectedTouches: updatedRejected };
        case 'CLEAR_REJECTED_TOUCHES':
            return { ...state, rejectedTouches: new Set() };
        case 'SET_ACTIVE_TOUCHES':
            return { ...state, activeTouches: action.payload };
        case 'ADD_RECENT_REJECTION':
            const rejections = [...state.recentRejections, action.payload].slice(-10);
            return { ...state, recentRejections: rejections };
        case 'SET_RECENT_REJECTIONS':
            return { ...state, recentRejections: action.payload };
        case 'CLEAR_RECENT_REJECTIONS':
            return { ...state, recentRejections: [] };
        case 'SET_ACTIVE_STROKES_BY_TOUCH':
            return { ...state, activeStrokesByTouch: action.payload };
        case 'SET_PRIMARY_DRAWING_TOUCH':
            return { ...state, primaryDrawingTouch: action.payload };
        case 'SET_INPUT_METHOD':
            return { ...state, currentInputMethod: action.payload };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
};

export const usePalmRejection = () => {
    const [state, dispatch] = useReducer(palmRejectionReducer, initialState);

    const actions = {
        addRejectedTouch: (touchId) => dispatch({ type: 'ADD_REJECTED_TOUCH', payload: touchId }),
        removeRejectedTouch: (touchId) => dispatch({ type: 'REMOVE_REJECTED_TOUCH', payload: touchId }),
        clearRejectedTouches: () => dispatch({ type: 'CLEAR_REJECTED_TOUCHES' }),
        setActiveTouches: (touches) => dispatch({ type: 'SET_ACTIVE_TOUCHES', payload: touches }),
        addRecentRejection: (rejection) => dispatch({ type: 'ADD_RECENT_REJECTION', payload: rejection }),
        setRecentRejections: (rejections) => dispatch({ type: 'SET_RECENT_REJECTIONS', payload: rejections }),
        clearRecentRejections: () => dispatch({ type: 'CLEAR_RECENT_REJECTIONS' }),
        setActiveStrokesByTouch: (strokes) => dispatch({ type: 'SET_ACTIVE_STROKES_BY_TOUCH', payload: strokes }),
        setPrimaryDrawingTouch: (touchId) => dispatch({ type: 'SET_PRIMARY_DRAWING_TOUCH', payload: touchId }),
        setInputMethod: (method) => dispatch({ type: 'SET_INPUT_METHOD', payload: method }),
        reset: () => dispatch({ type: 'RESET' })
    };

    return [state, actions];
};
